import React, { useEffect } from "react";
import "./App.css";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { initializeService } from "./Service/Services";
import { UserProvider } from "./Context/UserContext";
import { StoreProvider } from "./stores/StoreContext";
import EditProfileHome from "./Components/EditProfileHome";
import SignIn from "./HelperComponents/SignIn";
import DevImpersonationBanner from "./HelperComponents/DevImpersonationBanner";

// Basic content for authenticated and unauthenticated states
const MainContent: React.FunctionComponent = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <StoreProvider>
          <UserProvider>{<EditProfileHome />}</UserProvider>
          <DevImpersonationBanner />
        </StoreProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <SignIn />
      </UnauthenticatedTemplate>
    </>
  );
};

interface IAppProps {
  instance: PublicClientApplication;
}

export const App: React.FC<IAppProps> = ({ instance }) => {
  // Initialize MSAL service with token interceptors on app load
  useEffect(() => {
    initializeService(instance);
  }, [instance]);

  return <MsalProvider instance={instance}>{<MainContent />}</MsalProvider>;
};
